import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faBars, faTimes, faPencilAlt, faCalendar, faArrowUp, faArrowDown, faSpinner, faFileContract, faEllipsisH, faArrowRight, faPlus, faMinus, faFile
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub, faMicrosoft, faSalesforce
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faBars, faTimes, faPencilAlt, faCalendar, faArrowUp, faArrowDown, faSpinner, faFileContract, faEllipsisH, faGithub, faMicrosoft, faSalesforce, faArrowRight, faPlus, faMinus, faFile
)

Vue.component('fa', FontAwesomeIcon)

